__turbopack_context__.v({
  "container": "SocialLinks-module-scss-module__KEk-tq__container",
  "socialIcon": "SocialLinks-module-scss-module__KEk-tq__socialIcon",
});
